export default {
  add_cot_can_to_dai_tra_enrolment_plan_teachers:
    '/bdtx/dai-tra/add-cot-can-to-dai-tra-enrolment-plan-teachers',
};
